/* global php_vars */

( function ($) {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	// var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	// var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
	// 	return new bootstrap.Popover( popoverTriggerEl, {
	// 		trigger: 'focus',
	// 	} );
	// } );

	$(document).ready(function () {

		//offcanvas click event
		$('#navbarNavDropdown a').click(  function() {
			let href = $(this).attr('href');
			// check if internal jumpmark link
			if( href.startsWith('/#') ) {
				const offcanvas = new bootstrap.Offcanvas('#navbarNavDropdown');
				// Bug bs5?? on init the canvas is not set to shown
				offcanvas._isShown = true;
				offcanvas.hide();
			}
		})

		// if clicked on a link with a hash, scroll to the anchor
		$('a[href*="#"]').click(function(e) {
			// check if internal jumpmark link
			if( $(this).attr('href').startsWith('#') ) {
				e.preventDefault();
				// get the target
				let target = $(this).attr('href');
				// scroll to the target
				console.log("Target: ", target);
				if( ! target || target === '#' ) {
					return;
				}
				$('html, body').animate({
					scrollTop: $(target).offset().top - php_vars.scroll_offset
				}, php_vars.scrollcontainer_speed);
			}
		});

		// jump to anchor with animation
		if(location.hash) {
			window.scrollTo({
				top: $(location.hash).offset().top - 1000,
				left: 0,
				behavior: "instant"
			})
			// $('html,body').scrollTop( $(location.hash).offset().top - 200, {
			//     duration: 0
			// })
		}

		// toggle menu class
		$('.dropdown-toggle--mobile').click( function(e) {
			let viewportWidth = window.innerWidth;
			if( viewportWidth < 1170 ) {
				e.preventDefault();
				$(this).parent().toggleClass('open');
				// $(this).find('.megamenu')
				$(this).parent().find('.offcanvas-mobile-dropdown').toggleClass('open');
			}
		});

		$('.offcanvas-backlink').click( function(e) {
			e.preventDefault();
			$(this).parent().parent().removeClass('open');
		});

		// $('.has-megamenu a.dropdown-toggle').click(function (e) {
		//
		// 	// e.preventDefault();
		// 	// $(this).parent().toggleClass('open');
		// 	// if ($(this).parent().hasClass('open')) {
		// 	//     $('#wrapper-navbar').removeClass('has-bg');
		// 	// } else {
		// 	//     $('#wrapper-navbar').addClass('has-bg');
		// 	// }
		// })


	});
} )(jQuery);

(function mainScript() {
	// "use strict";
	// const offcanvasToggle = document.querySelector(
	//     '[data-bs-toggle="offcanvas"]',
	// );
	// const offcanvasCollapse = document.querySelector(".offcanvas-collapse");
	// offcanvasToggle.addEventListener("click", function () {
	//     console.log("Click");
	//     // offcanvasCollapse.classList.toggle("show");
	// });
})();
